import { normalizeUnitProfile } from "./units.js";

const SETTINGS_KEY = "jbm.settings";
const UNIT_OVERRIDES_KEY = "jbm.unitOverrides";

function storeSettings(settings) {
  localStorage.setItem(SETTINGS_KEY, JSON.stringify(settings));
  return settings;
}

export function loadSettings() {
  try {
    const value = JSON.parse(localStorage.getItem(SETTINGS_KEY) || "{}");
    return {
      theme: value.theme === "light" ? "light" : "dark",
      unitProfile: normalizeUnitProfile(value.unitProfile),
    };
  } catch (_) {
    return { theme: "dark", unitProfile: "imperial" };
  }
}

export function applyTheme(theme) {
  const normalized = theme === "light" ? "light" : "dark";
  document.documentElement.setAttribute("data-bs-theme", normalized);
  storeSettings({ ...loadSettings(), theme: normalized });

  const button = document.querySelector("#theme-toggle");
  if (button) {
    const nextTheme = normalized === "dark" ? "light" : "dark";
    button.classList.add("responsive-icon-action");
    button.setAttribute("aria-label", `Switch to ${nextTheme} theme`);
    button.setAttribute("title", `Switch to ${nextTheme} theme`);
    button.innerHTML = normalized === "dark"
      ? '<i class="bi bi-moon-stars-fill" aria-hidden="true"></i><span class="responsive-action-label">Dark</span>'
      : '<i class="bi bi-sun-fill" aria-hidden="true"></i><span class="responsive-action-label">Light</span>';
  }
  return normalized;
}

export function applyUnitProfile(profile) {
  const normalized = normalizeUnitProfile(profile);
  storeSettings({ ...loadSettings(), unitProfile: normalized });

  const select = document.querySelector("#unit-profile");
  if (select) select.value = normalized;
  return normalized;
}

export function loadUnitOverrides() {
  try {
    const value = JSON.parse(localStorage.getItem(UNIT_OVERRIDES_KEY) || "{}");
    return value && typeof value === "object" && !Array.isArray(value) ? value : {};
  } catch (_) {
    return {};
  }
}

export function setUnitOverride(calculatorSlug, fieldName, unitId) {
  const overrides = loadUnitOverrides();
  overrides[`${calculatorSlug}.${fieldName}`] = unitId;
  localStorage.setItem(UNIT_OVERRIDES_KEY, JSON.stringify(overrides));
  return unitId;
}

export function clearUnitOverridesForPrefix(calculatorSlug, fieldPrefix) {
  const overrides = loadUnitOverrides();
  const prefix = `${calculatorSlug}.${fieldPrefix}`;
  let removed = 0;
  for (const key of Object.keys(overrides)) {
    if (!key.startsWith(prefix)) continue;
    delete overrides[key];
    removed += 1;
  }
  if (removed > 0) {
    localStorage.setItem(UNIT_OVERRIDES_KEY, JSON.stringify(overrides));
  }
  return removed;
}

export function clearUnitOverrides() {
  localStorage.removeItem(UNIT_OVERRIDES_KEY);
}
